//Importaciones
import React, { useContext } from 'react'
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import List from '../../../../../Templates/List';
import { Card, Col, Row } from 'react-bootstrap';
import { Icon } from '@fluentui/react';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import { __onGoToBook } from '../../../../../../common/SystemRedirections';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
//import './style.css'

function ELEMENT_BOOK_STATUS_SUMMARY(props) {
    //Helpers
    const { t } = useTranslation();
    const history = useHistory();

    const { 
        inputParam_HideHeader = true,
        inputParam_ComponentContent = null,
        inputParam_UseFake = false,
    } = props;

    const [data, setData] = useState(__OBJECT_STRUCTURE_GetList(15, !inputParam_UseFake ? (inputParam_ComponentContent !== null ? inputParam_ComponentContent.items :[]) : [{
        code: '0000000',
        name: "Libro",
        title: "Comunicación",
    }]));

    const _columns = [
        {
            key: 'code',
            name: 'Código',
            fieldName: 'code',
            minWidth: 53,
            maxWidth: 53,
            onRender:(item) => {
                return <div onClick={() => __onGoToBook(item.bookId, history)}>{item.code}</div>
            }
        },{
            key: 'name',
            name: 'Nombre',
            fieldName: 'name',
            minWidth: 70,
            maxWidth: 70,
            onRender:(item) => {
                return <div onClick={() => __onGoToBook(item.bookId, history)}>{item.name}</div>
            }
        },{
            key: 'title',
            name: 'Título',
            fieldName: 'title',
            minWidth: 70,
            maxWidth: 70,
            onRender:(item) => {
                return <div onClick={() => __onGoToBook(item.bookId, history)}>{item.title}</div>
            }
        }
    ];

    const renderContent = () => {
        return  <Row className='text-center px-1' style={{opacity: inputParam_UseFake ? ".4" : ""}}>
                    <Col>
                        <List
                            manipulateLocalData={ true }
                            showHeaders={false}
                            listLocalStoragePageSizeVariableName="listep"
                            className="no-compact-list overflow-scroll"
                            data={data}
                            setData={setData} columns={_columns} />
                    </Col>
                </Row>
    }

    //Render de componente.
    return (
        <>
        {
            !inputParam_UseFake &&
            <Card className='h-100'>
                {
                    !inputParam_HideHeader &&
                    <Card.Header className="card-header-compact" style={{backgroundColor: "#16c2d0", color: "white"}}>
                        <Card.Title className="d-flex justify-content-between">
                            <Row className='w-100 p-0'>
                                <Col className='d-flex align-items-center p-0'>
                                    <Icon className='ps-3' iconName='RingerSolid' styles={{root:{fontSize: "24px"}}} />
                                </Col>
                                <Col className='text-end col-auto ms-auto me-1 my-auto p-0'>
                                    { inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-lbl-unansweredcommunications')}
                                </Col>
                            </Row>
                        </Card.Title>
                    </Card.Header>
                }
                <Card.Body className='p-0 h-100 overflow-hidden'>
                    {
                        renderContent()
                    }
                </Card.Body>
            </Card> 
        }
        {
            inputParam_UseFake && renderContent()
        }
        </>
           
    );
}

export default ELEMENT_BOOK_STATUS_SUMMARY;